import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { E360SessionService } from '../services/e360-session.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly e360SessionService: E360SessionService = inject(E360SessionService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // dont do anything if not a request going to an internal service
    if (!req.url.includes('enliven360.com')) {
      return next.handle(req);
    }

    if (this.e360SessionService.accessToken) {
      req = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${this.e360SessionService.accessToken}`)
      });
    }

    return next.handle(req);
  }
}
